__webpack_require__.p = "https://cdn.credible.com/partners-widgets/";